import manifest from "./sticker-manifest.json";

export interface StickerInfo {
  key: string;
  cat: string;
  w: number;
  h: number;
}

export const STICKERS: StickerInfo[] = manifest as StickerInfo[];

export const STICKER_CATEGORIES: { key: string; label: string }[] = [
  { key: "ideas", label: "Ideas" },
  { key: "study", label: "Study" },
  { key: "science", label: "Science" },
  { key: "tech", label: "Tech" },
  { key: "nature", label: "Nature" },
  { key: "decor", label: "Decor" },
  { key: "friends", label: "Friends" }
];

const byKey = new Map(STICKERS.map((s) => [s.key, s]));

export function stickerInfo(key: string): StickerInfo | undefined {
  return byKey.get(key);
}

export function stickerUrl(key: string): string {
  return `/stickers/${encodeURIComponent(key)}.webp`;
}

/** Human label for search: "thumbs-up" -> "thumbs up". */
export function stickerLabel(key: string): string {
  return key.replace(/-/g, " ");
}
